import { SimSeq, SimulationModal, updateSimSeq, EquipmentAttribute } from "@/services/project/simulation.service"
import { VariableTable } from "../VariableTable/VariableTable"
import { Button, Space, Tooltip } from "antd"
import Title from "antd/es/typography/Title"
import styles from './styles.module.less'
import { useEffect, useState } from "react"
import classNames from "classnames"
import { IconFont } from "@/components/IconFont"
import { useDispatch } from "react-redux"
import { AppDispatch } from "@/store"
import { reRunSimSeqThunk, runSimSeqThunk } from "@/store/flowsheet/actions"
import {cloneDeep} from 'lodash-es'
import { UnitStates } from "@/components/FlowSheetEditor/components/UnitSelect/UnitSelect"
import { useGetDisplayValue } from "../useGetDisplayValue"

enum SimSeqAction {
  Run,
  ReRun
}
interface SimSeqProps {
  seq: SimSeq,
  simulation: SimulationModal
  units: UnitStates
  reload?: () => void
}

export const SimSeqCompinent = (props: SimSeqProps) => {
  const {seq, simulation, units, reload} = props
  const getDisplayValue = useGetDisplayValue()

  const [editSeq, setEditSeq] = useState(seq)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    const cloneSeq = cloneDeep(seq) || {};
    const {intialGuess, target} = cloneSeq
    if (intialGuess) {
      fromDefaultVal(intialGuess)
    }
    if (target) {
      fromDefaultVal(target)
    }
    setEditSeq(cloneSeq)
  }, [seq])

  const fromDefaultVal = (values: EquipmentAttribute[]) => {
    if (values && values.length > 0) {
      values.forEach(item => {
        item.displayValue = getDisplayValue(units, item)
      })
    }
  }

  const onInitChange = (val) => {
    const newVal = {...editSeq, intialGuess: val}
    setEditSeq(newVal)
  }
  const onTargetChange = (val) => {
    const newVal = {...editSeq, target: val}
    setEditSeq(newVal)
  }

  const removeDisplayAttrs = (values: EquipmentAttribute[]) => {
    if (values && values.length > 0) {
      values.forEach(item => {
        delete item.displayValue
      })
    }
  }

  const save = async (autoReload = false) => {
    const {intialGuess, target} = cloneDeep(editSeq)
    if (intialGuess) {
      removeDisplayAttrs(intialGuess)
    }
    if (target) {
      removeDisplayAttrs(target)
    }
    await updateSimSeq({sequence: editSeq}, {sId: simulation.id, id: editSeq.index})
    if (autoReload) {
      reload && reload()
    }
  }


  const runSeq = async (action: SimSeqAction) => {
    await save()
    const params = {sId: simulation.id, id: editSeq.index}
    if (action === SimSeqAction.Run) {
      await dispatch(runSimSeqThunk(params)).unwrap()
    } else {
      await dispatch(reRunSimSeqThunk(params)).unwrap()
    }
    reload && reload()
  }
  
  return <div className={styles.container}>
    <Space className="flex-end">
      <Tooltip title="Upload to server">
        <Button icon={<IconFont type="icon-cloud-upload" />} onClick={() => save(true)} />
      </Tooltip>
      <Tooltip title="Solve while skipping the initialization sequence.">
        <Button icon={<IconFont type="icon-bachanglianxi" />} onClick={() => runSeq(SimSeqAction.ReRun)}/>
      </Tooltip>
      <Tooltip title="Run Full Sequence">
        <Button icon={<IconFont type="icon-run" />} onClick={() => runSeq(SimSeqAction.Run)}/>
      </Tooltip>
    </Space>
    <div className={classNames('mt-1', styles.content)}>
      <Title level={3}>Initial Guess</Title>
      <VariableTable value={editSeq.intialGuess} units={units} onChange={onInitChange} />
      <Title level={3} className="mt-1">Target Values</Title>
      <VariableTable value={editSeq.target} units={units} onChange={onTargetChange} />
      {/* <div className="actionRow mt-1">
        <Space>
          <Button>Cancel</Button>
          <Button type="primary" onClick={save}>Save</Button>
        </Space>
      </div> */}
    </div>
    
    
  </div>
}